export function initStackCards(selector = ".stack-cards") {

  const containers = document.querySelectorAll(selector)
  if (!containers.length) return

  const allCards = []

  containers.forEach(container => {
    const cards = Array.from(container.querySelectorAll(":scope > div"))
    if (!cards.length) return

    const total = cards.length
    cards.forEach((card, i) => {
      card.style.transformOrigin = "top center"
      card.style.willChange = "transform"
      allCards.push({ card, i, total })
    })
  })

  function updateCards() {
    allCards.forEach(({ card, i, total }) => {
      const rect = card.getBoundingClientRect()
      const progress = Math.min(Math.max(-rect.top / rect.height, 0), 1)
      const scale = 1 - progress * 0.05 * (total - i)
      card.style.transform = `scale(${scale})`
    })
  }

  window.addEventListener("scroll", updateCards, { passive: true })
  updateCards()

  return () => window.removeEventListener("scroll", updateCards)
}
